const __WEBPACK_NAMESPACE_OBJECT__ = tvg.deps.react['react-18'];